import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import Modal from 'react-modal'
import NumericKeyBoard from '../../components/NumericKeyBoard'
import { setSelectPagerModal } from '../actions/modalActions'
import { getTranslation } from '../../actions/dataActions'
import * as properties from '../../constants/Properties'
import * as resource from '../../constants/Resources'

function SelectPagerModal(propsModal) {
  const props = propsModal;
  const pagerNumberValue = props.selectPagerModal.callbackparams;
  const [pagerNumber, setPagerNumber] = useState({ pagerNumber: '' });

  useEffect(() => {
    if (props.selectPagerModal.show) {
      setPagerNumber({ pagerNumber: pagerNumberValue || '' });
    }
  }, [props.selectPagerModal.show, pagerNumberValue]);

  const handleOk = (value) => {
    const callback = props.selectPagerModal.callback;
    const dispatch = props.selectPagerModal.dispatch;
    if (value === '') {
      value = null;
    }
    if (callback) {
      if (callback !== null) {
        if (dispatch !== null) {
          dispatch(callback.apply(this, [value]));
        } else {
          callback.apply(this, value);
        }
      }
    }
    props.setSelectPagerModal(false, 'default');
  };

  const handleCancel = () => {
    const callback = props.selectPagerModal.callback;
    const dispatch = props.selectPagerModal.dispatch;
    if (callback) {
      if (callback !== null) {
        if (dispatch !== null) {
          dispatch(callback.apply(this, [null]));
        } else {
          callback.apply(this, null);
        }
      }
    }
    props.setSelectPagerModal(false, 'default');
  };

  return (
    <Modal className='selectPager'
      contentLabel=""
      isOpen={props.selectPagerModal.show}
      style={properties.selectPagerModalStyle}
    >
      <div className="selectPager_header">
        <div className="header_top">
          {props.getTranslation(resource.SELECT_PAGER)}
        </div>
      </div>
      <div className="selectPager_content">
        <NumericKeyBoard
          open={open}
          initialValue={pagerNumber.pagerNumber}
          onOk={handleOk}
          onCancel={handleCancel}
        />
      </div>
    </Modal>
  );
}

function mapStateToProps(state) {
  return {
    selectPagerModal: state.modalState.selectPagerModal,
  }
}

export default connect(mapStateToProps, {
  setSelectPagerModal,
  getTranslation,
})(SelectPagerModal)



// WEBPACK FOOTER //
// src/modal/components/SelectPagerModal.jsx